////////////////////////////////////////////////////////////
//  Program: PropertyConfigService.js                     //
//  Application: Property                                 //
//  Option: Used for manage Property SLA Config           //
////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

class PropertyConfigService {
  getPropertyConfig(propertySlug) {
    let endPoint = "property-config/" + propertySlug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  savePropertyConfig(data) {
    let endPoint = "property-config";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }
}

export default new PropertyConfigService();
